module.exports = __webpack_public_path__ + "_/img/MapMarker7.d82236a7.svg";